// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 10vh;
  height: 20vh;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: #2c5FFE;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */

@keyframes ldio-2j6q63zyi35 {
  0% { opacity: 1 }
  100% { opacity: 0 }
}
.ldio-2j6q63zyi35 div {
  left: 47.5px;
  top: 6px;
  position: absolute;
  animation: ldio-2j6q63zyi35 linear 0.9433962264150942s infinite;
  background: #2c5ffe;
  width: 5px;
  height: 20px;
  border-radius: 2.4px / 2.4px;
  transform-origin: 2.5px 44px;
}.ldio-2j6q63zyi35 div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -0.890985324947589s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(2) {
  transform: rotate(20deg);
  animation-delay: -0.8385744234800838s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(3) {
  transform: rotate(40deg);
  animation-delay: -0.7861635220125786s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(4) {
  transform: rotate(60deg);
  animation-delay: -0.7337526205450733s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(5) {
  transform: rotate(80deg);
  animation-delay: -0.681341719077568s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(6) {
  transform: rotate(100deg);
  animation-delay: -0.6289308176100629s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(7) {
  transform: rotate(120deg);
  animation-delay: -0.5765199161425576s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(8) {
  transform: rotate(140deg);
  animation-delay: -0.5241090146750523s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(9) {
  transform: rotate(160deg);
  animation-delay: -0.4716981132075471s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(10) {
  transform: rotate(180deg);
  animation-delay: -0.4192872117400419s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(11) {
  transform: rotate(200deg);
  animation-delay: -0.36687631027253664s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(12) {
  transform: rotate(220deg);
  animation-delay: -0.31446540880503143s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(13) {
  transform: rotate(240deg);
  animation-delay: -0.26205450733752617s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(14) {
  transform: rotate(260deg);
  animation-delay: -0.20964360587002095s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(15) {
  transform: rotate(280deg);
  animation-delay: -0.15723270440251572s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(16) {
  transform: rotate(300deg);
  animation-delay: -0.10482180293501048s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(17) {
  transform: rotate(320deg);
  animation-delay: -0.05241090146750524s;
  background: #2c5ffe;
}.ldio-2j6q63zyi35 div:nth-child(18) {
  transform: rotate(340deg);
  animation-delay: 0s;
  background: #2c5ffe;
}
.loadingio-spinner-spinner-z515pskmu3b {
  width: 60px;
  height: 60px;
  display: inline-block;
  overflow: hidden;
  background: #ffffff;
}
.ldio-2j6q63zyi35 {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(0.6);
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-2j6q63zyi35 div { box-sizing: content-box; }



/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */

.lds-hourglass {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-hourglass:after {
  content: " ";
  display: block;
  border-radius: 50%;
  width: 0;
  height: 0;
  margin: 8px;
  box-sizing: border-box;
  border: 32px solid #2c5FFE;
  border-color: #2c5FFE transparent #2c5FFE transparent;
  animation: lds-hourglass 1.2s infinite;
}

@keyframes lds-hourglass {
  0% {
    transform: rotate(0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  50% {
    transform: rotate(900deg);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  100% {
    transform: rotate(1800deg);
  }
}


/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #2c5FFE;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }

  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }

  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}


/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////// */

.lds-roller {
  display: inline-block;
  position: relative;
  width: auto;
  height: 20vh;
}

.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}

.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 100%;
  background: #2c5FFE;
  margin: -4px 0 0 -4px;
}

.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}

.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}

.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}

.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}

.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}

.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}

.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}

.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}

.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}

.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}

.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}

.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}

.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}

.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}

.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}

.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}

@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/loader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,wHAAwH;;AAExH;EACE,KAAK,WAAW;EAChB,OAAO,WAAW;AACpB;AACA;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,+DAA+D;EAC/D,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;AAC9B,CAAC;EACC,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;AACrB,CAAC;EACC,wBAAwB;EACxB,qCAAqC;EACrC,mBAAmB;AACrB,CAAC;EACC,wBAAwB;EACxB,qCAAqC;EACrC,mBAAmB;AACrB,CAAC;EACC,wBAAwB;EACxB,qCAAqC;EACrC,mBAAmB;AACrB,CAAC;EACC,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB,CAAC;EACC,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;EAC3B,qBAAqB,EAAE,mBAAmB;AAC5C;AACA,wBAAwB,uBAAuB,EAAE;;;;AAIjD,wHAAwH;;AAExH;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE;IACE,oBAAoB;IACpB,iEAAiE;EACnE;;EAEA;IACE,yBAAyB;IACzB,8DAA8D;EAChE;;EAEA;IACE,0BAA0B;EAC5B;AACF;;;AAGA,wHAAwH;;AAExH;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;;AAGA,mHAAmH;;AAEnH;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gEAAgE;EAChE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".lds-spinner {\r\n  color: official;\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 10vh;\r\n  height: 20vh;\r\n}\r\n.lds-spinner div {\r\n  transform-origin: 40px 40px;\r\n  animation: lds-spinner 1.2s linear infinite;\r\n}\r\n.lds-spinner div:after {\r\n  content: \" \";\r\n  display: block;\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 37px;\r\n  width: 6px;\r\n  height: 18px;\r\n  border-radius: 20%;\r\n  background: #2c5FFE;\r\n}\r\n.lds-spinner div:nth-child(1) {\r\n  transform: rotate(0deg);\r\n  animation-delay: -1.1s;\r\n}\r\n.lds-spinner div:nth-child(2) {\r\n  transform: rotate(30deg);\r\n  animation-delay: -1s;\r\n}\r\n.lds-spinner div:nth-child(3) {\r\n  transform: rotate(60deg);\r\n  animation-delay: -0.9s;\r\n}\r\n.lds-spinner div:nth-child(4) {\r\n  transform: rotate(90deg);\r\n  animation-delay: -0.8s;\r\n}\r\n.lds-spinner div:nth-child(5) {\r\n  transform: rotate(120deg);\r\n  animation-delay: -0.7s;\r\n}\r\n.lds-spinner div:nth-child(6) {\r\n  transform: rotate(150deg);\r\n  animation-delay: -0.6s;\r\n}\r\n.lds-spinner div:nth-child(7) {\r\n  transform: rotate(180deg);\r\n  animation-delay: -0.5s;\r\n}\r\n.lds-spinner div:nth-child(8) {\r\n  transform: rotate(210deg);\r\n  animation-delay: -0.4s;\r\n}\r\n.lds-spinner div:nth-child(9) {\r\n  transform: rotate(240deg);\r\n  animation-delay: -0.3s;\r\n}\r\n.lds-spinner div:nth-child(10) {\r\n  transform: rotate(270deg);\r\n  animation-delay: -0.2s;\r\n}\r\n.lds-spinner div:nth-child(11) {\r\n  transform: rotate(300deg);\r\n  animation-delay: -0.1s;\r\n}\r\n.lds-spinner div:nth-child(12) {\r\n  transform: rotate(330deg);\r\n  animation-delay: 0s;\r\n}\r\n@keyframes lds-spinner {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */\r\n\r\n@keyframes ldio-2j6q63zyi35 {\r\n  0% { opacity: 1 }\r\n  100% { opacity: 0 }\r\n}\r\n.ldio-2j6q63zyi35 div {\r\n  left: 47.5px;\r\n  top: 6px;\r\n  position: absolute;\r\n  animation: ldio-2j6q63zyi35 linear 0.9433962264150942s infinite;\r\n  background: #2c5ffe;\r\n  width: 5px;\r\n  height: 20px;\r\n  border-radius: 2.4px / 2.4px;\r\n  transform-origin: 2.5px 44px;\r\n}.ldio-2j6q63zyi35 div:nth-child(1) {\r\n  transform: rotate(0deg);\r\n  animation-delay: -0.890985324947589s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(2) {\r\n  transform: rotate(20deg);\r\n  animation-delay: -0.8385744234800838s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(3) {\r\n  transform: rotate(40deg);\r\n  animation-delay: -0.7861635220125786s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(4) {\r\n  transform: rotate(60deg);\r\n  animation-delay: -0.7337526205450733s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(5) {\r\n  transform: rotate(80deg);\r\n  animation-delay: -0.681341719077568s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(6) {\r\n  transform: rotate(100deg);\r\n  animation-delay: -0.6289308176100629s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(7) {\r\n  transform: rotate(120deg);\r\n  animation-delay: -0.5765199161425576s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(8) {\r\n  transform: rotate(140deg);\r\n  animation-delay: -0.5241090146750523s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(9) {\r\n  transform: rotate(160deg);\r\n  animation-delay: -0.4716981132075471s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(10) {\r\n  transform: rotate(180deg);\r\n  animation-delay: -0.4192872117400419s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(11) {\r\n  transform: rotate(200deg);\r\n  animation-delay: -0.36687631027253664s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(12) {\r\n  transform: rotate(220deg);\r\n  animation-delay: -0.31446540880503143s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(13) {\r\n  transform: rotate(240deg);\r\n  animation-delay: -0.26205450733752617s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(14) {\r\n  transform: rotate(260deg);\r\n  animation-delay: -0.20964360587002095s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(15) {\r\n  transform: rotate(280deg);\r\n  animation-delay: -0.15723270440251572s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(16) {\r\n  transform: rotate(300deg);\r\n  animation-delay: -0.10482180293501048s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(17) {\r\n  transform: rotate(320deg);\r\n  animation-delay: -0.05241090146750524s;\r\n  background: #2c5ffe;\r\n}.ldio-2j6q63zyi35 div:nth-child(18) {\r\n  transform: rotate(340deg);\r\n  animation-delay: 0s;\r\n  background: #2c5ffe;\r\n}\r\n.loadingio-spinner-spinner-z515pskmu3b {\r\n  width: 60px;\r\n  height: 60px;\r\n  display: inline-block;\r\n  overflow: hidden;\r\n  background: #ffffff;\r\n}\r\n.ldio-2j6q63zyi35 {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  transform: translateZ(0) scale(0.6);\r\n  backface-visibility: hidden;\r\n  transform-origin: 0 0; /* see note above */\r\n}\r\n.ldio-2j6q63zyi35 div { box-sizing: content-box; }\r\n\r\n\r\n\r\n/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */\r\n\r\n.lds-hourglass {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n\r\n.lds-hourglass:after {\r\n  content: \" \";\r\n  display: block;\r\n  border-radius: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  margin: 8px;\r\n  box-sizing: border-box;\r\n  border: 32px solid #2c5FFE;\r\n  border-color: #2c5FFE transparent #2c5FFE transparent;\r\n  animation: lds-hourglass 1.2s infinite;\r\n}\r\n\r\n@keyframes lds-hourglass {\r\n  0% {\r\n    transform: rotate(0);\r\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n  }\r\n\r\n  50% {\r\n    transform: rotate(900deg);\r\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(1800deg);\r\n  }\r\n}\r\n\r\n\r\n/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */\r\n\r\n.lds-ripple {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n\r\n.lds-ripple div {\r\n  position: absolute;\r\n  border: 4px solid #2c5FFE;\r\n  opacity: 1;\r\n  border-radius: 50%;\r\n  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\r\n}\r\n\r\n.lds-ripple div:nth-child(2) {\r\n  animation-delay: -0.5s;\r\n}\r\n\r\n@keyframes lds-ripple {\r\n  0% {\r\n    top: 36px;\r\n    left: 36px;\r\n    width: 0;\r\n    height: 0;\r\n    opacity: 0;\r\n  }\r\n\r\n  4.9% {\r\n    top: 36px;\r\n    left: 36px;\r\n    width: 0;\r\n    height: 0;\r\n    opacity: 0;\r\n  }\r\n\r\n  5% {\r\n    top: 36px;\r\n    left: 36px;\r\n    width: 0;\r\n    height: 0;\r\n    opacity: 1;\r\n  }\r\n\r\n  100% {\r\n    top: 0px;\r\n    left: 0px;\r\n    width: 72px;\r\n    height: 72px;\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n\r\n/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////// */\r\n\r\n.lds-roller {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: auto;\r\n  height: 20vh;\r\n}\r\n\r\n.lds-roller div {\r\n  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\r\n  transform-origin: 40px 40px;\r\n}\r\n\r\n.lds-roller div:after {\r\n  content: \" \";\r\n  display: block;\r\n  position: absolute;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 100%;\r\n  background: #2c5FFE;\r\n  margin: -4px 0 0 -4px;\r\n}\r\n\r\n.lds-roller div:nth-child(1) {\r\n  animation-delay: -0.036s;\r\n}\r\n\r\n.lds-roller div:nth-child(1):after {\r\n  top: 63px;\r\n  left: 63px;\r\n}\r\n\r\n.lds-roller div:nth-child(2) {\r\n  animation-delay: -0.072s;\r\n}\r\n\r\n.lds-roller div:nth-child(2):after {\r\n  top: 68px;\r\n  left: 56px;\r\n}\r\n\r\n.lds-roller div:nth-child(3) {\r\n  animation-delay: -0.108s;\r\n}\r\n\r\n.lds-roller div:nth-child(3):after {\r\n  top: 71px;\r\n  left: 48px;\r\n}\r\n\r\n.lds-roller div:nth-child(4) {\r\n  animation-delay: -0.144s;\r\n}\r\n\r\n.lds-roller div:nth-child(4):after {\r\n  top: 72px;\r\n  left: 40px;\r\n}\r\n\r\n.lds-roller div:nth-child(5) {\r\n  animation-delay: -0.18s;\r\n}\r\n\r\n.lds-roller div:nth-child(5):after {\r\n  top: 71px;\r\n  left: 32px;\r\n}\r\n\r\n.lds-roller div:nth-child(6) {\r\n  animation-delay: -0.216s;\r\n}\r\n\r\n.lds-roller div:nth-child(6):after {\r\n  top: 68px;\r\n  left: 24px;\r\n}\r\n\r\n.lds-roller div:nth-child(7) {\r\n  animation-delay: -0.252s;\r\n}\r\n\r\n.lds-roller div:nth-child(7):after {\r\n  top: 63px;\r\n  left: 17px;\r\n}\r\n\r\n.lds-roller div:nth-child(8) {\r\n  animation-delay: -0.288s;\r\n}\r\n\r\n.lds-roller div:nth-child(8):after {\r\n  top: 56px;\r\n  left: 12px;\r\n}\r\n\r\n@keyframes lds-roller {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
